import type { PortableTextBlock } from '@portabletext/react';

interface Options {
  nonTextBehavior: 'remove';
}

const defaults: Options = { nonTextBehavior: 'remove' };

export function convertPortableTextToPlainText(
  blocks: PortableTextBlock[],
  opts: Partial<Options> = {}
): string {
  if (!Array.isArray(blocks)) {
    return '';
  }

  const options = { ...defaults, ...opts };
  return blocks
    .map((block) => {
      if (!block || typeof block !== 'object') {
        return '';
      }

      if (block._type !== 'block' || !block.children) {
        return options.nonTextBehavior === 'remove'
          ? ''
          : `[${block._type ?? 'unknown'} block]`;
      }

      if (!Array.isArray(block.children)) {
        return '';
      }

      return block.children
        .map((child) => {
          if (!child || typeof child !== 'object') {
            return '';
          }
          return child.text ?? '';
        })
        .join('');
    })
    .join('\n\n')
    .replace(/\n/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
